<table mat-table class="stripped-table mat-elevation-z2" [dataSource]="dataSource" matSort>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlet Name</th>
    <td mat-cell *matCellDef="let row"><a href="{{row.fundUrl}}" target="_blank" class="data-link">{{row.name}}</a></td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlet Type</th>
    <td mat-cell *matCellDef="let row">{{row.type}}</td>
  </ng-container>
  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
    <td mat-cell *matCellDef="let row">{{row.role}}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef=outletColumns></tr>
  <tr mat-row *matRowDef="let row; columns: outletColumns"></tr>
</table>
